import React, { useState } from 'react';
import { get } from 'lodash';
import { Radio } from 'components';
import './termsAndMessaging.less';

const { APP_URL } = require('utils/env');

export default function MessagingPolicy({
  hasTextMessageOptIn,
  setField,
  fieldsErrors,
}) {
  const [textMessageOptIn, setTextMessageOptIn] = useState(hasTextMessageOptIn);
  const handleMessage = () => {
    setTextMessageOptIn(!textMessageOptIn);
    setField(!textMessageOptIn);
  };

  return (
    <>
      <p className="bodycopy2">
        By checking the box below, I authorize Nue Life and its affiliates to
        contact me by automated SMS text message. I may opt out anytime by
        choosing Opt-Out option at the end of the text message. Opting out of
        automated SMS messaging shall not restrict my receiving of services,
        subject to the{' '}
        <a
          rel="noreferrer"
          target="_blank"
          href={`${APP_URL}/terms-conditions`}>
          terms and conditions.
        </a>{' '}
        I understand that message/data rates may apply to messages sent by Nue
        Life Health or its affiliates under my cell phone plan
      </p>

      <Radio
        className="textMessageOptInRadio"
        error={fieldsErrors && get(fieldsErrors, 'textMessageOptIn')}
        checked={textMessageOptIn}
        name="textMessageOptIn"
        onChange={handleMessage}
        label={<>I agree to SMS text messaging policy</>}
        type="checkbox"
      />
    </>
  );
}